class MarqueeComponent extends HTMLElement {
  connectedCallback() {
    // Defer until layout is ready
    requestAnimationFrame(() => this._setup());
  }

  disconnectedCallback() {
    clearTimeout(this._resizeTimer);
    window.removeEventListener('resize', this._onResize);
  }

  _setup() {
    const wrapper = this.querySelector('.marquee__wrapper');
    const content = this.querySelector('.marquee__content');
    const firstItems = this.querySelector('.marquee__repeated-items');

    if (!wrapper || !content || !firstItems) return;

    // Remove any previously cloned content (on re-init)
    wrapper.querySelectorAll('[aria-hidden="true"]').forEach((el) => el.remove());
    content.querySelectorAll('.marquee__repeated-items:not(:first-child)').forEach((el) => el.remove());

    const containerWidth = this.offsetWidth || window.innerWidth;
    const itemsWidth = firstItems.offsetWidth;

    if (!itemsWidth) return;

    // Fill the container with enough copies so there are no gaps
    const copies = Math.max(1, Math.ceil(containerWidth / itemsWidth));
    for (let i = 1; i < copies; i++) {
      const clone = firstItems.cloneNode(true);
      clone.removeAttribute('ref');
      content.appendChild(clone);
    }

    // Duplicate the entire content block for seamless looping
    const contentClone = content.cloneNode(true);
    contentClone.setAttribute('aria-hidden', 'true');
    contentClone.removeAttribute('ref');
    wrapper.appendChild(contentClone);

    // Calculate and set speed (same formula as original)
    const speedFactor = Number(this.dataset.speedFactor) || 25;
    const speed = Math.sqrt(copies) * speedFactor;
    this.style.setProperty('--marquee-speed', speed + 's');

    // Pause on hover
    this.addEventListener('pointerenter', this._pause = () => {
      const anim = wrapper.getAnimations()[0];
      if (anim) anim.playbackRate = 0.3;
    }, { once: false });
    this.addEventListener('pointerleave', this._resume = () => {
      const anim = wrapper.getAnimations()[0];
      if (anim) anim.playbackRate = 1;
    }, { once: false });

    // Re-init on resize (debounced)
    window.addEventListener('resize', this._onResize = () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._setup(), 250);
    });
  }
}

if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', MarqueeComponent);
}
